import React, { FunctionComponent, useMemo } from "react";
import { Grid, makeStyles, Theme, Typography, useMediaQuery, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { GeneVariationExplanationHero } from "./gene-variation-explanation-hero";
import { GeneVariationExplanationHeroMobile } from "./gene-variation-explanation-hero-mobile";

const useStyles = makeStyles((theme: Theme) => ({
  header: {
    fontWeight: 700,
    fontSize: 26,
    marginBottom: theme.spacing(2),
  },
  explain: {
    fontSize: 18,
    fontWeight: 300,
    marginBottom: theme.spacing(6),
  },
  bodyText: {
    fontSize: 16,
    fontWeight: 300,
    marginBottom: theme.spacing(6),
  },
  hero: {
    width: "100%",
    height: "100%",
  },
  mobileHero: {
    marginTop: theme.spacing(4),
    width: "100%",
    maxWidth: "380px",
    height: "100%",
  },
}));

interface IGeneVariationExplanationProps {}

export const GeneVariationExplanation: FunctionComponent<IGeneVariationExplanationProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const showMobile = useMemo(() => isXs || isMd, [isXs, isMd]);

  return (
    <Grid container>
      <Grid item container direction="row">
        <Typography className={classes.header}>{t("gene_variations.page_1.header")}</Typography>
      </Grid>
      <Grid item container direction="row">
        <Typography className={classes.explain}>{t("gene_variations.page_2.explanation")}</Typography>
      </Grid>
      <Grid item container direction="row">
        <Typography className={classes.bodyText}>{t("gene_variations.page_2.body_1")}</Typography>
      </Grid>
      <Grid item container direction="row">
        <Typography className={classes.bodyText}>{t("gene_variations.page_2.body_2")}</Typography>
      </Grid>
      <Grid item container direction="row" justify="center" style={{ paddingTop: theme.spacing(2), width: "100%" }}>
        {!showMobile && <GeneVariationExplanationHero className={classes.hero} />}
        {showMobile && <GeneVariationExplanationHeroMobile className={classes.mobileHero} />}
      </Grid>
    </Grid>
  );
};
